import { LanguageCode, TLCode } from '../common/enums';

const en = require('./en.json');
const fr = require('./fr.json');
const nl = require('./nl.json');

const locales = {
  en,
  fr,
  nl,
};

export function GetText(tlcode: TLCode | string, languageCode: LanguageCode | string) {
  // const langSelected = LanguageCode[languageCode]; // LanguageCode[LanguageCode.en];
  const code = TLCode[tlcode];
  // return locales[langSelected][code];
  return locales[languageCode][code];
}

export default locales;
